// extracted by mini-css-extract-plugin
module.exports = {"canvas":"ImageAudit_canvas__k2WMa","panning":"ImageAudit_panning__e2CxH","selecting":"ImageAudit_selecting__RW1fO"};